import React, { useState, useEffect } from 'react'
import ReactTable from 'react-table'
import selectTableHOC from 'react-table/lib/hoc/selectTable'
import { Select } from 'antd'

const { Option } = Select

const SelectTable = selectTableHOC(ReactTable)

const TagTable = ({
    event,
    onSelectedTagValueIdsChanged,
    initialTagKeyId,
    initialSelectAll,
    initialSelectedTagValueIds,
}) => {
    const [selectedTagKeyId, setSelectedTagKeyId] = useState(initialTagKeyId)
    const [selectedTagValueIds, setSelectedTagValueIds] = useState(
        initialSelectedTagValueIds,
    )
    const [selectAllChecked, setSelectAllChecked] = useState(initialSelectAll)

    const initialSelectedTagValueIdsJoined = initialSelectedTagValueIds.join(
        ',',
    )

    useEffect(() => {
        setSelectAllChecked(initialSelectAll)
        setSelectedTagKeyId(initialTagKeyId)
        setSelectedTagValueIds(initialSelectedTagValueIds)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialSelectedTagValueIdsJoined, initialTagKeyId, initialSelectAll])

    if (event.tags.length === 0) return <em>No sales were found</em>

    const isSelected = tagValueId => selectedTagValueIds.includes(tagValueId)

    const parseKeyAsTagValueId = key => parseInt(key.replace('select-', ''), 10)

    const toggleSelection = key => toggleTagValueId(parseKeyAsTagValueId(key))

    const toggleTagValueId = tagValueId => {
        const tagValueIndex = selectedTagValueIds.indexOf(tagValueId)

        if (tagValueIndex === -1) {
            const updatedSelectedTagValueIds = [
                ...selectedTagValueIds,
                tagValueId,
            ]

            const haveAllBeenSelected =
                updatedSelectedTagValueIds.length ===
                getAllTagValueIdsForTheSelectedTagKey().length

            updateState({
                tagValuesAllSelected: haveAllBeenSelected,
                tagValueIds: updatedSelectedTagValueIds,
            })
        } else {
            updateState({
                tagValuesAllSelected: false,
                tagValueIds: [
                    ...selectedTagValueIds.slice(0, tagValueIndex),
                    ...selectedTagValueIds.slice(tagValueIndex + 1),
                ],
            })
        }
    }

    const getTagValuesForTagKey = tagKeyId => {
        const tag = event.tags.find(tag => tag.id === tagKeyId)
        if (tag) return tag.tagValues

        return []
    }

    const getTagValueIdsForTagKey = tagKeyId =>
        getTagValuesForTagKey(tagKeyId).map(tagValue => tagValue.id)

    const getAllTagValueIdsForTheSelectedTagKey = () =>
        getTagValueIdsForTagKey(selectedTagKeyId)

    const toggleAll = () => {
        const selectAll = !selectAllChecked
        const selectedTagValueIds = selectAll
            ? getAllTagValueIdsForTheSelectedTagKey()
            : []

        updateState({
            tagValuesAllSelected: selectAll,
            tagValueIds: selectedTagValueIds,
        })
    }

    const getTdProps = (state, rowInfo, column, instance) => {
        if (rowInfo != null)
            return {
                style: { cursor: 'pointer' },
                onClick: (e, handleOriginal) => {
                    e.stopPropagation()
                    toggleTagValueId(rowInfo.row._original.id)

                    if (handleOriginal) {
                        handleOriginal()
                    }
                },
            }
    }

    const handleTagKeyChange = tagKeyId =>
        updateState({
            tagKeyId: tagKeyId,
            tagValuesAllSelected: true,
            tagValueIds: getTagValueIdsForTagKey(tagKeyId),
        })

    const updateState = ({
        tagKeyId = selectedTagKeyId,
        tagValuesAllSelected = selectAllChecked,
        tagValueIds = selectedTagValueIds,
    }) => {
        setSelectedTagKeyId(tagKeyId)
        setSelectAllChecked(tagValuesAllSelected)
        setSelectedTagValueIds(tagValueIds)

        onSelectedTagValueIdsChanged({
            eventId: event.eventId,
            tagKeyId,
            tagValueIds: tagValuesAllSelected ? [] : tagValueIds,
        })
    }

    return (
        <div>
            <SelectTable
                data={getTagValuesForTagKey(selectedTagKeyId)}
                keyField="id"
                columns={[
                    {
                        Header: () => (
                            <Select
                                defaultValue={selectedTagKeyId}
                                style={{ width: '100%' }}
                                size="small"
                                onChange={handleTagKeyChange}
                            >
                                {event.tags.map(tag => (
                                    <Option key={tag.id} value={tag.id}>
                                        {tag.label}
                                    </Option>
                                ))}
                            </Select>
                        ),
                        accessor: 'label',
                    },
                ]}
                minRows={0}
                showPagination={false}
                defaultPageSize={500}
                sortable={false}
                isSelected={isSelected}
                selectAll={selectAllChecked}
                toggleSelection={toggleSelection}
                getTdProps={getTdProps}
                toggleAll={toggleAll}
            ></SelectTable>
        </div>
    )
}

export default TagTable
